import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@lciapps/auth';
import { ProtectedComponent } from './protected/protected.component';
import { AuthCallbackComponent } from './root/auth-callback.component';
import { RootComponent } from './root/root.component';
import { SignoutComponent } from './root/signout.component';

const routes: Routes = [
  {
    path: 'auth-callback',
    component: AuthCallbackComponent
  },
  {
    path: 'signout',
    component: SignoutComponent
  },
  {
    path: '',
    redirectTo: 'account',
    pathMatch: 'full',
  },
  {
    path: 'root',
    component: RootComponent,
    children: [{
      path: 'protected',
      component: ProtectedComponent,
      canActivate: [AuthGuard]
    }]
  },
  {
    path: 'account',
    loadChildren: 'app/account/account.module#AccountModule'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
